import { useEffect, useState } from "react";
import { categoryOfCardKey } from "@/lib/api";
import { TileArt } from "@/components/game/InfraArt";
import { tileImageSrc, logMissingArt } from "@/lib/artAssets";

// One thin wavy line used on sea squares and over submerged Mangroves.
export function WaveLine({ y = 50, opacity = 1 }) {
  return (
    <svg viewBox="0 0 100 100" preserveAspectRatio="none" className="absolute inset-0 w-full h-full pointer-events-none" aria-hidden="true">
      <path
        d={`M6 ${y} Q 17 ${y - 6}, 28 ${y} T 50 ${y} T 72 ${y} T 94 ${y}`}
        fill="none"
        stroke="var(--shallow)"
        strokeWidth="1.5"
        strokeLinecap="round"
        vectorEffect="non-scaling-stroke"
        opacity={opacity}
      />
    </svg>
  );
}

export function TileImage({ cardKey, legacy = true, opacity = 1, fading = false }) {
  const src = tileImageSrc(cardKey);
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [src]);
  return (
    <div className="absolute inset-0 overflow-hidden" aria-hidden="true" style={{ opacity, animation: fading ? "demolish-fade 180ms ease-in forwards" : undefined }}>
      {src && !failed ? (
        <img
          src={src}
          alt=""
          data-testid="tile-art-img"
          draggable={false}
          decoding="async"
          className="w-full h-full select-none"
          style={{ objectFit: "cover" }}
          onError={() => {
            logMissingArt(src);
            setFailed(true);
          }}
        />
      ) : (
        legacy && <TileArt cardKey={cardKey} category={categoryOfCardKey(cardKey)} />
      )}
    </div>
  );
}
